import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

import { STRIPE_STATUS_QUERY_KEY } from "./useStripeStatus";

// Mints a single-use, short-lived Stripe onboarding link. Deliberately a
// mutation rather than a query — the link must never be cached and a fresh
// one must be requested immediately before every redirect.
export const useStripeOnboardingLink = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/stripe/onboarding-link`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [STRIPE_STATUS_QUERY_KEY, tenantVal],
      });
    },
  });
};
